var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.dataLoading,
              expression: "dataLoading"
            }
          ],
          staticClass: "vilocal-root"
        },
        [
          _c("div", { staticClass: "slogan-row" }, [
            _c("div", [
              _c("div", { staticClass: "slogan" }, [
                _vm._v("Continuous new arrivals, curated by ViLocal!")
              ]),
              _vm._v(" "),
              !_vm.isMobile
                ? _c("div", { staticClass: "black-line" })
                : _vm._e()
            ]),
            _vm._v(" "),
            !_vm.isMobile
              ? _c(
                  "div",
                  { ref: "searchBox", staticClass: "search-box" },
                  [
                    _c("el-input", {
                      attrs: {
                        "prefix-icon": "el-icon-search",
                        placeholder:
                          "Search for the brands and products you are interested in",
                        clearable: ""
                      },
                      on: { focus: _vm.focusHandle, change: _vm.changeHandle },
                      model: {
                        value: _vm.searchInput,
                        callback: function($$v) {
                          _vm.searchInput = $$v
                        },
                        expression: "searchInput"
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _vm.isMobile
            ? _c(
                "div",
                { ref: "searchBox", staticClass: "search-box" },
                [
                  _c("el-input", {
                    attrs: {
                      "prefix-icon": "el-icon-search",
                      placeholder:
                        "Search for the brands and products you are interested in",
                      clearable: ""
                    },
                    on: { change: _vm.changeHandle, focus: _vm.focusHandle },
                    model: {
                      value: _vm.searchInput,
                      callback: function($$v) {
                        _vm.searchInput = $$v
                      },
                      expression: "searchInput"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.localStoreList && _vm.localStoreList.length > 0
            ? _c(
                "div",
                { staticClass: "card-container" },
                _vm._l(_vm.localStoreList, function(item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      ref: index,
                      refInFor: true,
                      staticClass: "vilocal-card card"
                    },
                    [
                      _c("div", { staticClass: "goods" }, [
                        item.vilocalType !== 4
                          ? _c("div", { staticClass: "discount-tag" }, [
                              _vm._v("\n          100% OFF\n        ")
                            ])
                          : _c("div", { staticClass: "discount-tag" }, [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    (item.discountTrialRate * 100).toFixed(0)
                                  ) +
                                  "% OFF\n        "
                              )
                            ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "card-detail-swiper" },
                          [
                            item.goodsList.length == 1
                              ? _c("img", {
                                  staticClass: "card-img",
                                  attrs: { src: item.goodsList[0].spuImg },
                                  on: {
                                    click: function($event) {
                                      return _vm.toGoodsDetail(
                                        item.goodsList[0].seoUrl,
                                        item.goodsList[0]
                                      )
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            item.goodsList.length == 1
                              ? _c("div", { staticClass: "price" }, [
                                  _c("span", { staticClass: "live-price" }, [
                                    _vm._v(
                                      _vm._s(
                                        Number(
                                          item.vilocalType !== 4
                                            ? 0
                                            : item.goodsList[0]
                                                .discountTrialWholeSalePrice
                                        ).toLocaleString("en-US", {
                                          style: "currency",
                                          currency: "USD"
                                        })
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "original-price" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            Number(
                                              item.goodsList[0].wholeSalePrice
                                            ).toLocaleString("en-US", {
                                              style: "currency",
                                              currency: "USD"
                                            })
                                          )
                                      )
                                    ]
                                  ),
                                  _vm._v(
                                    "\n            Wholesale Price\n          "
                                  )
                                ])
                              : _c(
                                  "swiper",
                                  {
                                    ref: _vm.getRefName(item.collectionBrandId),
                                    refInFor: true,
                                    staticClass: "swiper pcSwiper2",
                                    attrs: {
                                      options: _vm.localStoreSwiperOption
                                    },
                                    on: {
                                      slideChange: function($event) {
                                        return _vm.handleSlideChange(item)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "el-icon-arrow-left smail-img-swiper-prev",
                                      attrs: { slot: "button-prev" },
                                      on: {
                                        click: function($event) {
                                          return _vm.leftClick(item)
                                        }
                                      },
                                      slot: "button-prev"
                                    }),
                                    _vm._v(" "),
                                    _vm._l(item.goodsList, function(img, key) {
                                      return _c(
                                        "swiper-slide",
                                        {
                                          key: key,
                                          ref: "swiperImg",
                                          refInFor: true
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "card-detail" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "img-detail" },
                                                [
                                                  _c("img", {
                                                    staticClass: "card-img",
                                                    attrs: { src: img.spuImg },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.toGoodsDetail(
                                                          img.seoUrl,
                                                          img
                                                        )
                                                      }
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "price" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "live-price"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          Number(
                                                            item.vilocalType !==
                                                              4
                                                              ? 0
                                                              : img.discountTrialWholeSalePrice
                                                          ).toLocaleString(
                                                            "en-US",
                                                            {
                                                              style: "currency",
                                                              currency: "USD"
                                                            }
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "original-price"
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            Number(
                                                              img.wholeSalePrice
                                                            ).toLocaleString(
                                                              "en-US",
                                                              {
                                                                style:
                                                                  "currency",
                                                                currency: "USD"
                                                              }
                                                            )
                                                          )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    "\n                  Wholesale Price\n                "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    }),
                                    _vm._v(" "),
                                    _c("i", {
                                      staticClass:
                                        "el-icon-arrow-right smail-img-swiper-next",
                                      attrs: { slot: "button-next" },
                                      on: {
                                        click: function($event) {
                                          return _vm.rightClick(item)
                                        }
                                      },
                                      slot: "button-next"
                                    })
                                  ],
                                  2
                                )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        item.vilocalStatus === 2
                          ? _c(
                              "div",
                              {
                                staticClass: "wholesale-static-circle-completed"
                              },
                              [
                                item.vilocalStatus === 2
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "wholesale-static-circle-completed-text"
                                      },
                                      [_vm._v("Completed")]
                                    )
                                  : _vm._e()
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.goodsList.length == 1
                          ? _c("div", { staticClass: "action-area" }, [
                              item.vilocalStatus === 0 &&
                              !_vm.isExitsViLocalOrder
                                ? _c(
                                    "h4",
                                    {
                                      staticClass: "wholesale-static",
                                      on: {
                                        click: function($event) {
                                          return _vm.oneClickOrder(
                                            item.collectionBrandId,
                                            item
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n            Get ViLocal Order\n          "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.vilocalStatus === 1 &&
                              !_vm.isExitsViLocalOrder
                                ? _c(
                                    "h4",
                                    {
                                      staticClass: "wholesale-static-pre-order",
                                      on: {
                                        click: function($event) {
                                          return _vm.oneClickOrder(
                                            item.collectionBrandId,
                                            item
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n            Pre-Order\n          "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.vilocalStatus === 2
                                ? _c(
                                    "h4",
                                    {
                                      staticClass: "wholesale-static-completed",
                                      on: {
                                        click: function($event) {
                                          return _vm.oneClickOrder(
                                            item.collectionBrandId,
                                            item
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n            Waiting to Reopen\n          "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              (item.vilocalStatus === 0 ||
                                item.vilocalStatus === 1) &&
                              _vm.isExitsViLocalOrder
                                ? _c(
                                    "h4",
                                    { staticClass: "wholesale-static-placed" },
                                    [
                                      _vm._v(
                                        "\n            ViLocal order placed\n          "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          : _c("div", { staticClass: "action-area" }, [
                              item.vilocalStatus === 0 &&
                              !_vm.isExitsViLocalOrder
                                ? _c(
                                    "h4",
                                    {
                                      staticClass: "wholesale",
                                      on: {
                                        click: function($event) {
                                          return _vm.oneClickOrder(
                                            item.collectionBrandId,
                                            item
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n            Get ViLocal Order\n          "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.vilocalStatus === 1 &&
                              !_vm.isExitsViLocalOrder
                                ? _c(
                                    "h4",
                                    {
                                      staticClass: "wholesale-pre-order",
                                      on: {
                                        click: function($event) {
                                          return _vm.oneClickOrder(
                                            item.collectionBrandId,
                                            item
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n            Pre-Order\n          "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.vilocalStatus === 2
                                ? _c(
                                    "h4",
                                    {
                                      staticClass: "wholesale-completed",
                                      on: {
                                        click: function($event) {
                                          return _vm.oneClickOrder(
                                            item.collectionBrandId,
                                            item
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n            Waiting to Reopen\n          "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              (item.vilocalStatus === 0 ||
                                item.vilocalStatus === 1) &&
                              _vm.isExitsViLocalOrder
                                ? _c(
                                    "h4",
                                    { staticClass: "wholesale-placed" },
                                    [
                                      _vm._v(
                                        "\n            ViLocal order placed\n          "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "vilocal-type-tips" }, [
                        _vm._v(_vm._s(item.vilocalTypeTips))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "vilocal-info" }, [
                        _c("div", { staticClass: "brand" }, [
                          _c("img", {
                            staticClass: "brand-logo",
                            attrs: { src: item.brandLogoUrl },
                            on: {
                              click: function($event) {
                                return _vm.toBrandDetail(
                                  item.collectionBrandSeoUrl,
                                  item
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass: "brand-name",
                              on: {
                                click: function($event) {
                                  return _vm.toBrandDetail(
                                    item.collectionBrandSeoUrl,
                                    item
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(item.collectionBrandName))]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "vilocal-progress" },
                          [
                            _c("div", { staticClass: "progress-info-bar" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "progress-info",
                                  style: {
                                    left:
                                      _vm.calculateInfoOffset(
                                        item.vilocalProgressPercentage
                                      ) + "px"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(item.vilocalProgressPercentage) +
                                      "% to go"
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "triangle",
                                style: {
                                  left:
                                    _vm.calculateArrowOffset(
                                      item.vilocalProgressPercentage
                                    ) + "px"
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("el-progress", {
                              staticClass: "progress",
                              attrs: {
                                color: "#262613",
                                percentage: item.vilocalProgressPercentage,
                                "show-text": false
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  )
                }),
                0
              )
            : _c("div", { staticClass: "no-data-container" }, [
                _c("img", {
                  staticClass: "no-data-img",
                  attrs: {
                    src: require("@/assets/img/vilocal/vilocal-dialog-img.png")
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "no-data-info" }, [
                  _vm._v("No results found")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "no-data-btn",
                    on: { click: _vm.noDataBtnGetList }
                  },
                  [_vm._v("Back")]
                )
              ])
        ]
      ),
      _vm._v(" "),
      _c("PageCom", {
        staticClass: "pageSize page",
        attrs: {
          currentPage: _vm.pageNo,
          total: _vm.total,
          pageSize: _vm.pageSize,
          pageOptions: _vm.options
        },
        on: {
          handleSizeChange: _vm.handleSizeChange,
          handleCurrentChange: _vm.handleCurrentChange
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "horizontal-divider" }, [
      _c("div", { staticClass: "grey-line" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-926f3222", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-926f3222","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/vilocal/vilocal-product.vue
// module id = null
// module chunks = 